import SelectOrDatePicker from '../../../../components/Modal/SelectOrDatePicker';
import { Form } from 'antd';
import { Dayjs } from 'dayjs';

interface SelectExpiresDateProps {
  value?: string;
  onChange?: (value: string) => void;
}

const SelectExpiresDate = ({ value, onChange }: SelectExpiresDateProps) => {
  const handleChange = (newValue: string | null, _: Date | null, startDate: Dayjs | null) => {
    if (newValue && startDate && !isNaN(Number(newValue))) {
      const newExpireDate = startDate.add(Number(newValue), 'day').format('MM-DD-YYYY');
      onChange?.(newExpireDate);
    } else {
      onChange?.(newValue || '');
    }
  };

  if (!value) return null;
  return (
    <Form.Item noStyle shouldUpdate>
      {({ getFieldValue }) => {
        const startDate = getFieldValue('startDate');
        return (
          <SelectOrDatePicker
            disabled={!startDate}
            onChange={(value, date) => handleChange(value, date, startDate)}
            valueDf={value || ''}
          />
        );
      }}
    </Form.Item>
  );
};

export default SelectExpiresDate;
